import React from 'react';
import PropTypes from 'prop-types';

export default function AvatarIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 13 17" fill={color} {...rest}>
      <path d="M6.50019536,8.60929289 C4.59954316,8.60929289 3.05869425,6.68205621 3.05869425,4.3046716 C3.05869425,1.92723669 3.56467525,0 6.50019536,0 C9.43571545,0 9.94159875,1.92723669 9.94159875,4.3046716 C9.94159875,6.68205621 8.4007499,8.60929289 6.50019536,8.60929289 Z M12.9927229,14.4045828 C12.9967766,14.6694912 12.9989255,14.7153106 13,14.6916716 C12.9998534,14.7618846 12.9997558,14.8650917 12.9997558,15.0135148 C12.9997558,15.0135148 12.0427875,17 6.50014652,17 C0.957407882,17 0.000537238208,15.0135148 0.000537238208,15.0135148 C0.000537238208,14.7825059 0.000244199257,14.6500266 0,14.5784053 C0.0010744772,14.6166301 0.0038583492,14.5993284 0.00986565281,14.2700414 C0.0831254511,10.2374704 0.640290631,10.1813905 4.61561148,9.44254438 C4.61561148,9.44254438 5.18147016,10.1849616 6.50014652,10.1849616 C7.81882289,10.1849616 8.38458391,9.44254438 8.38458391,9.44254438 C12.4037629,10.1895384 12.9289868,10.2631213 12.9927229,14.4045828 Z" />
    </svg>
  );
}

AvatarIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

AvatarIcon.defaultProps = {
  size: 15,
  color: '#000',
};
